// extracted by mini-css-extract-plugin
export default {"disc":"_364yB"};